




























import { Component, Prop, Mixins } from "vue-property-decorator";
import { User } from "@/models";
import UsersMixin from "@/mixins/http/User";
import QueryableInterface from "../interfaces/QueryableInterface";

const DEFAULT_PLACEHOLDER = "Cerca per indirizzo e-mail";
const DEFAULT_MIN = 3;
const DEFAULT_DELAY = 750;

const REQUEST_TAG = "users";

@Component({
  components: {},
})
export default class UserSearch extends Mixins(UsersMixin) {
  @Prop() readonly value!: User | null;
  @Prop({ default: DEFAULT_PLACEHOLDER }) readonly placeholder?: string;
  @Prop({ default: DEFAULT_MIN }) readonly min?: number;
  @Prop({ default: DEFAULT_DELAY }) readonly delay?: number;

  term = "";
  timeout: number | undefined;

  results: User[] = [];

  searching = false;

  dropdownVisible = false;

  async search() {
    const params: QueryableInterface = {
      page: {
        size: 100,
        number: 1,
      },
      filter: {
        term: this.term,
      },
    };

    this.results = [];
    this.searching = true;
    this.results = await this.getUsers(params, REQUEST_TAG);
    this.searching = false;
    this.$emit("searched", this.results);

    this.showDropdown();
  }

  focus() {
    if (this.$refs.input) {
      (this.$refs.input as HTMLInputElement).focus();
    }
  }

  protected showDropdown() {
    this.dropdownVisible = true;
  }

  protected closeDropdown() {
    this.dropdownVisible = false;
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  protected onKeyUp() {
    if (this.min && this.term.length >= this.min) {
      this.clearTimeout();

      this.timeout = setTimeout(() => {
        this.search();
      }, this.delay);
    } else if (this.term.length == 0) {
      this.results = [];
    }
  }

  protected select(value: User) {
    this.term = value.email as string;
    this.$emit("input", value.clone());
    this.closeDropdown();
  }
}
